(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('p2UpdateProcedureEdit', {
        templateUrl: 'views/components/views/p2UpdateProcedureEdit/p2UpdateProcedureEdit.template.html?v=' + module.version,
        controllerAs: 'vm',
        bindings: {
            p2UpdateProcedureKeyno: '<?',
            onSave: '&'
        },
        controller: ['$stateParams', 'stateService', 'p2UpdateProcedureEditService', 'layoutService', function ($stateParams, stateService, p2UpdateProcedureEditService, layoutService) {
            const vm = this;
            let p2UpdateProcedureKeyno = vm?.p2UpdateProcedureKeyno ?? $stateParams.p2_updateprocedure_keyno;
            let tabletSize = layoutService.getMediaQueries().tablet;
            
            vm.model = {
                tabletSize: tabletSize,
                edit: {},
                lockedSave: false
            };

            let loadEdit = function () {
                p2UpdateProcedureEditService.getUpdateProcedure({ p2_updateprocedure_keyno: p2UpdateProcedureKeyno }).then(function (info) {
                    angular.copy(info[0], vm.model.edit);
                });
            };
            
            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                p2UpdateProcedureEditService.saveObj(vm.model.edit).then(function () {
                    vm.model.lockedSave = false;

                    if (angular.isFunction(vm.onSave) && tabletSize.matches === true) {
                        vm.onSave();
                    } else {
                        stateService.back();
                    }
                }, function () {
                    vm.model.lockedSave = false;
                });
            };

            vm.$onInit = function () {
                //loadEdit();
            };

            vm.$onChanges = function (changes) {
                if (changes?.p2UpdateProcedureKeyno?.currentValue) {
                    p2UpdateProcedureKeyno = changes.p2UpdateProcedureKeyno.currentValue;
                }

                if (p2UpdateProcedureKeyno) loadEdit();
            };
        }]
    });
})();
